import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, Typography, useTheme } from '@material-ui/core';
import KenCard from '../../../global_components/KenCard';
import KenLoader from '../../../Components/KenLoader/index';
import { getRoleTypes } from '../../../Utils/apiServices';
import FacultyRole from './components/facultyRole';
import { useTranslation } from 'react-i18next';
import context from '../../../Utils/context';
import SelectInstitute from '../../../Components/SelectInstitute/index';
import SearchContact from '../../../Components/SearchContact';

const useStyles = makeStyles((theme) => ({
  roles: {
    fontSize: 13,
    fontWeight: 'bold',
    color: theme.palette.KenColors.neutral400,
  },
  container: {
    marginTop: 8,
  },
  roleType: {
    padding: 24,
    color: theme.palette.KenColors.KenBlack,
    textAlign: 'center',
    fontStyle: 'italic',
    fontSize: 13,
    '&:hover': {
      cursor: 'pointer',
    },
    background: theme.palette.KenColors.neutral40,
    borderRadius: 10,
  },
}));

export default function AssignRoles() {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [loader, setLoader] = useState();
  const [selectedInstitute, setSelectedInstitute] = useState();
  const [contactInfo, setContactInfo] = useState();
  const [roleType, setRoleType] = useState();
  const [role, setRole] = useState();

  const { handleSnackbarOpen } = React.useContext(context);

  useEffect(() => {
    getRoleTypes()
      .then((res) => {
        const arr = res?.map((el) => {
          return {
            type: el.type,
            selected: false,
          };
        });
        setRoleType(arr);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [selectedInstitute]);

  const onChangeInstitute = (e) => {
    setSelectedInstitute(e?.target?.value);
    setLoader(true);
    setRole();
    setContactInfo();
  };

  const handleRole = (e, type) => {
    if (selectedInstitute && contactInfo) {
      setRole(type);
      const arr = roleType?.map((el) => {
        if (type === el.type) {
          el.selected = true;
        } else {
          el.selected = false;
        }
        return el;
      });
      setRoleType(arr);
    } else {
      if (!selectedInstitute) {
        handleSnackbarOpen('error', t('messages:Please_Select_an_Institute'));
      } else if (!contactInfo) {
        handleSnackbarOpen('error', t('messages:Please_Select_a_Contact'));
      }
    }
  };

  return (
    <Grid>
      {loader && <KenLoader />}
      <Typography>{t('labels:RABC')}</Typography>
      <KenCard>
        <Grid container direction="column" spacing={2}>
          <Grid item md={4}>
            <SelectInstitute
              setLoader={setLoader}
              selectedInstitute={selectedInstitute}
              onChange={onChangeInstitute}
              placeholder={'Search...'}
            />
          </Grid>
          <Grid item md={4}>
            <SearchContact
              id={selectedInstitute}
              value={contactInfo}
              setLoader={setLoader}
              onChange={setContactInfo}
            />
          </Grid>
          <Grid item md={4} style={{ marginBottom: -24 }}>
            <Typography className={classes.roles}>
              {t('labels:Select_Role')}
            </Typography>
            <Grid
              container
              justify="space-between"
              spacing={2}
              alignItems="center"
            >
              {roleType &&
                roleType?.map((el) => {
                  return (
                    <Grid
                      item
                      md={4}
                      className={classes.container}
                      onClick={(e) => {
                        handleRole(e, el?.type);
                      }}
                    >
                      <Typography
                        className={classes.roleType}
                        name={el.type}
                        style={
                          el?.selected
                            ? {
                                color: theme.palette.KenColors.kenWhite,
                                backgroundColor:
                                  theme.palette.KenColors.primary,
                              }
                            : {}
                        }
                      >
                        {el.type}
                      </Typography>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
          <Grid item md={4}>
            <FacultyRole
              role={role}
              setLoader={setLoader}
              handleSnackbarOpen={handleSnackbarOpen}
              contactInfo={contactInfo}
              selectedInstitute={selectedInstitute}
            />
          </Grid>
        </Grid>
      </KenCard>
    </Grid>
  );
}
